import React from 'react';
import { AlertTriangle } from 'lucide-react';
import BaseModal from '../common/BaseModal';

/**
 * ConfirmModal - Confirmation dialog for dangerous actions
 */
function ConfirmModal({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  confirmText = 'Confirm', 
  cancelText = 'Cancel',
  variant = 'danger' // 'danger', 'warning', 'info'
}) {
  const icon = (variant === 'danger' || variant === 'warning') ? (
    <AlertTriangle className={`modal-icon ${variant}`} size={24} />
  ) : null;

  const footer = (
    <>
      <button className="btn btn-secondary" onClick={onClose}>
        {cancelText}
      </button>
      <button 
        className={`btn btn-${variant}`} 
        onClick={() => {
          onConfirm();
          onClose();
        }}
      >
        {confirmText}
      </button>
    </>
  );

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      icon={icon}
      footer={footer}
      size="small"
    >
      <div className="modal-body">
        <p>{message}</p>
      </div>
    </BaseModal>
  );
}

export default ConfirmModal;
